











import { Component, Prop, Vue } from 'vue-property-decorator';
import SubMenuItem from '@/components/menu/SubMenuItem.vue';
import { SubMenuModel } from '@/models/SubMenuModel';
import { MenuItemModel } from '@/models/MenuItemModel';

@Component({
  components: {
    SubMenuItem,
  },
})
export default class SubMenuSection extends Vue {
  @Prop() private menuId!: number;

  @Prop() private subMenu!: SubMenuModel;

  @Prop() private onItemClick!: (item: MenuItemModel) => void;

  get items(): MenuItemModel[] {
    return this.subMenu.items;
  }
}
